<div *ngFor="let i of innerItems; let index = index">
    <label class="checkbox">
      <input type="checkbox"
        [name]="'filter_checkbox_item_' + i"
        [(ngModel)]="i.checked"
        (ngModelChange)="changed.emit({ items: innerItems })">
      <span class="ms-2">  {{i.caption}}</span>
    </label>
  </div>
  <div *ngIf="items.length == 0">No Data Found</div>
